import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const offerApi = createApi({
  reducerPath: 'offerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Offer'],
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: () => '/api/admin/getOffers',
      providesTags: ['Offer'],
    }),

    addEditOffer: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/addOffer',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Offer'],
    }),

    deleteOffer: builder.mutation({
      query: (id) => ({
        url: `/api/admin/deleteOffer/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Offer'],
    }),
  }),
});

export const {
  useGetOffersQuery,
  useAddEditOfferMutation,
  useDeleteOfferMutation,
} = offerApi;
